import { useEffect, useCallback } from 'react';
import useHttp from '../http/useHttp';
import PortalType from '../../Models/Locations/portalType';

export default function useFetchPortalTypes() {
  const { getDataResponse, getData } = useHttp();

  const init = useCallback(async () => {
    await getData('lookup/getportaltypes');
  }, []);

  let portalTypes: PortalType[] = getDataResponse?.data ?? [];

  useEffect(() => {
    init();
  }, [init]);

  return { portalTypes };
}
